import React, { useState, useEffect } from 'react';
import { Plus } from 'lucide-react';
import { Button } from './ui/button';

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleCTAClick = () => {
    window.open('https://sistema.benmais.com/auto-contratacao?ref=MWZkYjg4ZDEtYzdiOC00ZTZiLWEzZDAtMGE5YjlkMjQ5ZTBhOmJiOGZmOTBiLWM5NjYtNDVmZi05MzAwLTUwNTkwMzhjYTczMQ==', '_blank');
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      scrolled ? 'bg-white shadow-lg' : 'bg-white/95 backdrop-blur-sm'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center gap-2">
            <span className="text-2xl sm:text-3xl font-bold text-[#0A1E2E]">Ben</span>
            <Plus className="w-6 h-6 sm:w-7 sm:h-7 text-[#00E5CC]" strokeWidth={3} />
            <span className="text-xl sm:text-2xl font-bold text-[#0A1E2E]">ALLCRED</span>
            <span className="ml-1 text-sm text-gray-600 hidden sm:inline">Proteção e Benefícios</span>
          </div>
          
          <div className="flex items-center gap-4">
            <Button
              onClick={handleCTAClick}
              className="bg-[#00E5CC] hover:bg-[#00D4BE] text-[#0A1E2E] font-bold px-6 py-2 transition-all duration-300 hover:shadow-lg hover:scale-105"
            >
              <Plus className="w-4 h-4 mr-2" strokeWidth={3} />
              Quero os Benefícios
            </Button>
          </div>
        </div>
      </div>
    </nav>
  );
};
